import React from 'react';
import { MdArrowDropDown, MdCheckBox } from 'react-icons/md';
import { DropdownMenu } from 'ui';
import { userMembersAction, UserMembersTranslation } from '../constants';
import { useListActionsCallbacks, useListSelectors } from '../hooks';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import styles from './user-members-list-header-visibility.scss';

interface UserMembersListHeaderActionsProps {
  searchFilterChanged: boolean;
  translation: UserMembersTranslation;
}

export const UserMembersListHeaderActions: React.FC<UserMembersListHeaderActionsProps> = ({
  searchFilterChanged, translation
}) => {

  const { addListActions } = useListActionsCallbacks();
  const { selectedRows } = useListSelectors();

  const toasts = toastFactory();

  const notify = (callback: () => void) => {
    if (searchFilterChanged) {
      toasts.dispatchInfo(translation.mark_all_info);
    } else {
      callback();
    }
  };

  const markAllSelected = () => {
    notify(() => addListActions([[]], userMembersAction.selectAll, true));
  };

  const markAllUnselected = () => {
    notify(() => addListActions([[]], userMembersAction.deselectAll, true));
  };

  const markHighlightedSelected = () => {
    addListActions(selectedRows, userMembersAction.select, false);
  };

  const markHighlightedUnselected = () => {
    addListActions(selectedRows, userMembersAction.deselect, true);
  };

  const buttonNode = <div className={styles.hasMaxWidth}>
    <MdCheckBox className={styles.visibilityIcon} />
    <span className={styles.visibilityLabel}>{translation.mark_rows}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  return <DropdownMenu dropdownNode={buttonNode} closeAfterClick>
    <li>
      <button id="mark-all-selected" className="dropdown-item" type="button" onClick={markAllSelected}>
        {translation.mark_all_selected}
      </button>
    </li>
    <li>
      <button id="mark-all-unselected" className="dropdown-item" type="button" onClick={markAllUnselected}>
        {translation.mark_all_unselected}
      </button>
    </li>
    <li>
      <button id="mark-highlighted-selected" className="dropdown-item" type="button" onClick={markHighlightedSelected}>
        {translation.mark_highlighted_selected}
      </button>
    </li>
    <li>
      <button id="mark-highlighted-unselected" className="dropdown-item" type="button" onClick={markHighlightedUnselected}>
        {translation.mark_highlighted_unselected}
      </button>
    </li>
  </DropdownMenu>;
};
